import { registerLocaleData } from '@angular/common';
import localeNb from '@angular/common/locales/nb';
import { ApplicationConfig, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';

export const appConfig: ApplicationConfig = {
  providers: [{ provide: LOCALE_ID, useValue: 'nb-NO' }, provideZonelessChangeDetection()],
};

registerLocaleData(localeNb, 'nb-NO');
